import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { claimDripOffer } from '../../redux/actions/myAccountAction'
import { SETTING } from 'routes/routeConstant'
import { hapticSuccess } from 'utils/haptics'
import ClaimLanding from './ClaimLanding'

/**
 * /claim/offer — one-click link from the re-engagement emails (and the taster
 * correction upsell). Claims the personal 50%-off-3-months voucher, then lands
 * on the plan page with the code prefilled (/setting?coupon=CODE#plan) so the
 * discounted prices show without any typing. Ineligible or failed claims land
 * on the plain plan page.
 */
const ClaimOffer: React.FC = () => {
  const { t } = useTranslation('offers')
  const navigate = useNavigate()
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) return // guard the StrictMode double-mount — the claim is one-shot
    hasRun.current = true
    ;(async () => {
      let couponCode = ''
      let expiresAt = 0
      try {
        const res: any = await claimDripOffer()
        if (res?.eligible && typeof res?.code === 'string' && res.code.length > 0) {
          couponCode = res.code
          // Unix seconds — carried to the plan page as ?until= so it can show
          // a live countdown to the offer deadline.
          if (typeof res?.expiresAt === 'number' && isFinite(res.expiresAt) && res.expiresAt > 0) {
            expiresAt = Math.floor(res.expiresAt)
          }
          hapticSuccess()
        }
      } catch (e) {
        // fall through to the plain plan page
      }
      const params = new URLSearchParams()
      if (couponCode) params.set('coupon', couponCode)
      if (couponCode && expiresAt) params.set('until', String(expiresAt))
      const search = params.toString()
      navigate(
        {
          pathname: SETTING,
          search: search ? `?${search}` : '',
          hash: '#plan',
        },
        { replace: true },
      )
    })()
  }, [])

  return <ClaimLanding message={t('claim.preparingOffer')} />
}

export default ClaimOffer
